// extracted by mini-css-extract-plugin
module.exports = {"shipIdsPanel":"styles_shipIdsPanel__zcT84","list":"styles_list__by1Bd","listItem":"styles_listItem__plmR3","id":"styles_id__1WEqr","name":"styles_name__3uRU5"};